// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"q0-z","subtitle":"r0-z","wrapper":"s0-z","leftArrow":"t0-z","rightArrow":"u0-z"};